import { size } from "lodash";
import { getTimezoneFromFragment } from "@radarly/models/fragment";
import { Post } from "@radarly/models/posts";
import { SearchFragmentPosts } from "@radarly/models/search";
import { useWidgetFragmentData } from "./useWidgetFragmentData";

const EMPTY_HITS = [];

export function usePostsWidgetData(
  project: number,
  fragment: SearchFragmentPosts,
  mutualized: boolean = true
) {
  const { data, isError, loading } = useWidgetFragmentData(
    project,
    fragment,
    mutualized
  );
  const timezone = getTimezoneFromFragment(fragment);
  const posts: Post[] = data?.hits || EMPTY_HITS;
  const total = data?.total || 0;
  return {
    loading,
    posts,
    total,
    isEmpty: !total || !size(posts),
    timezone,
    isError,
  };
}
